export const flexColumnCentered = {
  display: "flex",
  flexDirection: ["row", "column"],
  alignItems: "center",
  justifyContent: ["flex-start", "space-between"],
}

export const flexRowBetweenResponsiveColumnStart = {
  display: "flex",
  flexDirection: ["column", "row"],
  alignItems: ["flex-start", "center"],
  justifyContent: "space-between",
}

export default { flexColumnCentered, flexRowBetweenResponsiveColumnStart }
